import React, { Component } from 'react';

import RootView from '../rootView';
import PedidoDetalhe from '../../components/pedidoDetalhe';

class PedidoDetalheScreen extends Component {
    render() {
        const { navigation, showItemActions } = this.props;

        return (
            <RootView navigation={navigation}>
                <PedidoDetalhe
                    navigation={navigation}
                    showItemActions={showItemActions}
                />
            </RootView>
        );
    }
}

export default PedidoDetalheScreen;
